export default function (route) {
  return route.includes('{{') && route.includes('}}');
}



// WEBPACK FOOTER //
// ./src/helpers/routeHasVar.js